<template>
  <div class="d-flex justify-center" :style="{ padding: '10px' }">
    <v-card
      class="d-flex pa-2 flex-column align-center justify-center"
      outlined
      :style="{
        'margin-bottom': '40px',
        width: '80%',
        'min-height': '550px',
        height: 'fit-content',
      }"
      elevation="2"
    >
      <h3 class="ma-2 text-center">Bulk Upload - {{ uploadType }}</h3>
      <div
        class="d-flex flex-row justify-center align-center flex-wrap"
        :style="{
          'text-align': 'center',
          width: '85%',
          padding: '50px 0px 50px 0px',
        }"
      >
        <div
          class="d-flex flex-column justify-center align-center"
          style="flex: 1"
          v-if="isUpdate"
        >
          <v-row align="center" class="ma-1" style="width: 80%" v-if="isUpdate">
            <v-autocomplete
              v-model="selectedMerchants"
              :items="merchants"
              persistent-hint
              label="Merchant"
              placeholder="select merchant"
              multiple
              outlined
              prepend-inner-icon="mdi-store"
              item-text="merchant_name"
              return-object
              :loading="loadingMerchant"
              :search-input.sync="searchMerchant"
              :error-messages="selectedMerchantsErrors"
            >
              <v-list-item
                slot="prepend-item"
                ripple
                @click="toggle"
                :disabled="loadingMerchant"
              >
                <v-list-item-action>
                  <v-icon
                    :color="
                      selectedMerchants.length > 0 ? 'indigo darken-4' : ''
                    "
                    >{{ icon }}</v-icon
                  >
                </v-list-item-action>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item>
              <v-divider slot="prepend-item" class="mt-2" />
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index == 0">
                  <span>{{ item.merchant_name }}</span>
                </v-chip>
                <span v-if="index == 1" class="grey--text caption">
                  (+{{ selectedMerchants.length - 1 }} others)
                </span>
              </template>
            </v-autocomplete>
          </v-row>
          <v-row class="mb-4 mt-1">
            <v-btn
              v-if="isUpdate"
              :loading="loadingDownloadFile"
              :disabled="loadingDownloadFile"
              small
              @click="getDownloadFile"
            >
              Download Template
            </v-btn>
          </v-row>
        </div>
        <div
          class="d-flex flex-column justify-center align-center"
          style="flex: 1"
        >
          <v-row align="center" class="ma-1" style="width: 60%">
            <v-file-input
              label="Data Merchant (.xlsx)"
              placeholder="Select your files"
              :accept="validate.file_bulk_merchant.type.join()"
              persistent-hint
              outlined
              prepend-inner-icon="mdi-paperclip"
              prepend-icon=""
              v-model="fileBulkMerchant"
              @click="clearLastResult()"
              @focus="fileBulkMerchantFocus += 1"
              :error-messages="fileBulkMerchantErrors"
              @change="$v.fileBulkMerchant.$touch()"
              @blur="$v.fileBulkMerchant.$touch()"
            />
          </v-row>
          <v-row v-if="onUpload" style="width: 60%" class="mb-5">
            <h4>Uploading..</h4>
            <v-progress-linear
              v-model="uploadProgress"
              :active="onUpload"
              :query="true"
            />
          </v-row>
          <v-row v-if="onInsert" style="width: 60%" class="mb-5">
            <h4>{{ insertName }}</h4>
            <v-progress-linear
              v-model="insertProgress"
              :active="onInsert"
              :query="true"
            />
          </v-row>

          <v-row v-if="loading" style="width: 60%" class="mb-5">
            <h4>Generating download file..</h4>
            <v-progress-linear :indeterminate="loading" />
          </v-row>
          <v-row
            class="d-flex flex-column justify-center mb-5"
            v-if="downloadFailedURL != ''"
            style="width: 60%"
          >
            <v-card
              class="d-flex flex-column text-left pa-5"
              style="font-size: 13px"
            >
              <h3>Last result :</h3>
              <div style="color: green">
                {{ countSuccess }} record berhasil !
              </div>
              <div style="color: red; margin-bottom: 10px">
                {{ countFailed }} record gagal !
              </div>
              <div class="text--primary">
                Klik
                <a @click="downloadFailed" @keydown.enter="downloadFailed"
                  >Download</a
                >
                untuk mengunduh data yang gagal kedalam file .xls
              </div>
            </v-card>
          </v-row>
          <v-row class="mb-1" v-if="!isUpdate">
            <v-btn small @click="downloadBaseTemplate">
              Download Template
            </v-btn>
          </v-row>
          <v-row align="center" class="mb-4 mt-1">
            <v-btn
              small
              color="success"
              :disabled="onUpload || onInsert"
              :loading="onUpload || onInsert"
              @click="upload"
              :style="{ margin: '2px' }"
            >
              Upload
            </v-btn>
            <v-btn
              small
              color="warning"
              :disabled="onUpload"
              @click="back"
              :style="{ margin: '2px' }"
            >
              Kembali
            </v-btn>
          </v-row>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { validations } from '../../store/params';
import { date, showAlert } from '../../lib/helpers';

export default {
  name: 'step2',
  mixins: [validationMixin],
  validations: {
    selectedMerchants: {
      required() {
        return this.selectedMerchants.length >= 1;
      },
    },
    fileBulkMerchant: {
      required() {
        if (this.fileBulkMerchantFocus > 1) {
          return this.fileBulkMerchant != null;
        }
        return true;
      },
      fileType() {
        if (this.fileBulkMerchant != null) {
          return !!validations.file_bulk_merchant.type.includes(
            this.fileBulkMerchant.type.toLowerCase()
          );
        }
        return true;
      },
    },
  },
  mounted() {
    this.downloadTemplate();
  },
  data() {
    return {
      validate: validations,
      fileBulkMerchant: null,
      downloadURL: '',
      fileBulkMerchantFocus: 0,
      merchants: [],
      selectedMerchants: [],
      searchMerchant: '',
      loadingDownloadFile: false,
    };
  },
  beforeCreate() {
    if (this.$route.params.id != 'update-maintenance-settlement') {
      this.$router.back();
    }
  },
  watch: {
    searchMerchant: {
      handler() {
        this.getListMerchant();
      },
    },
  },
  computed: {
    uploadType() {
      let type = '';
      if (this.$route.params.id == 'add') type = 'Add';
      else if (this.$route.params.id == 'update-maintenance-settlement') {
        type = 'Update Maintenance Settlement';
      } else if (this.$route.params.id == 'update-non-pten') {
        type = 'Update Merchant Non PTEN';
      }
      return type;
    },
    loading() {
      return this.$store.state.maintenanceSettlement.loading;
    },
    loadingMerchant() {
      return this.$store.state.maintenanceSettlement.loadingListMerchant;
    },
    isUpdate() {
      return (
        this.$route.params.id == 'update-maintenance-settlement' ||
        this.$route.params.id == 'update-non-pten'
      );
    },
    isPTEN() {
      let ptenVal = false;
      if (this.$route.params.id == 'update-maintenance-settlement') {
        ptenVal = true;
      }
      if (this.$route.params.id == 'update-non-pten') {
        ptenVal = false;
      }
      return ptenVal;
    },
    uploadProgress() {
      return this.$store.state.maintenanceSettlement.uploadProgress;
    },
    onUpload() {
      return this.$store.state.maintenanceSettlement.onUpload;
    },
    insertProgress() {
      return this.$store.state.maintenanceSettlement.insertProgress;
    },
    insertName() {
      return this.$store.state.maintenanceSettlement.insertName;
    },
    onInsert() {
      return this.$store.state.maintenanceSettlement.onInsert;
    },
    countSuccess() {
      return this.$store.state.maintenanceSettlement.countSuccess;
    },
    countFailed() {
      return this.$store.state.maintenanceSettlement.countFailed;
    },
    downloadFailedURL() {
      return this.$store.state.maintenanceSettlement.downloadFailedURL;
    },
    fileBulkMerchantErrors() {
      const errors = [];
      if (!this.$v.fileBulkMerchant.$dirty) return errors;
      if (!this.$v.fileBulkMerchant.required)
        errors.push('File Merchant is required for upload');
      if (!this.$v.fileBulkMerchant.fileType)
        errors.push('Incorrect filetype Merchant File');
      return errors;
    },
    selectedMerchantsErrors() {
      const errors = [];
      if (!this.$v.selectedMerchants.$dirty) return errors;
      if (!this.$v.selectedMerchants.required)
        errors.push('Merchant is required for template');
      return errors;
    },
    selectAllMerchant() {
      const idMerchants = this.merchants.map((val) => val.id);
      const selectedIdMerchant = this.selectedMerchants.map((val) => val.id);
      return (
        idMerchants.filter((x) => selectedIdMerchant.includes(x)).length ==
        this.merchants.length
      );
    },
    selectSomeMerchant() {
      return this.selectedMerchants.length > 0 && !this.selectAllMerchant;
    },
    icon() {
      if (this.selectAllMerchant) return 'mdi-close-box';
      if (this.selectSomeMerchant) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },
  methods: {
    downloadFailed() {
      window.location.href = this.downloadFailedURL;
    },
    downloadBaseTemplate() {
      window.location.href = this.downloadURL;
    },
    back() {
      this.$router.push('/maintenance-settlement');
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectAllMerchant) {
          this.selectedMerchants = [];
        } else {
          const selectedIdMerchant = this.selectedMerchants.map(
            (val) => val.id
          );
          const diff = this.merchants.filter(
            (x) => !selectedIdMerchant.includes(x.id)
          );
          this.selectedMerchants = this.selectedMerchants.concat(diff);
        }
      });
    },
    getListMerchant() {
      this.$store
        .dispatch('maintenanceSettlement/getListMerchant', {
          searchMerchant: { merchant_name: this.searchMerchant },
          date,
        })
        .then((response) => {
          if (response) {
            this.merchants = response.list;
          }
        });
    },
    getDownloadFile() {
      const ids = this.selectedMerchants.map((merchant) => merchant.id);
      this.$v.selectedMerchants.$touch();
      if (!this.$v.selectedMerchants.$error) {
        if (ids.length > 0) {
          this.loadingDownloadFile = true;
          this.$store
            .dispatch('maintenanceSettlement/generateMerchant', {
              merchant_id: ids,
              date,
            })
            .then((response) => {
              if (response) {
                window.location.href = response.download;
              }
            })
            .finally(() => {
              this.loadingDownloadFile = false;
            });
        } else {
          showAlert(
            this.$store,
            'Merchant must be selected !',
            'mdi-alert',
            'red'
          );
        }
      }
    },
    upload() {
      this.$store.commit('maintenanceSettlement/clearLastResult');
      this.fileBulkMerchantFocus = 2;
      this.$v.fileBulkMerchant.$touch();
      if (!this.$v.fileBulkMerchant.$error) {
        if (this.isUpdate) {
          this.$store
            .dispatch('maintenanceSettlement/bulkUpload', {
              file: this.fileBulkMerchant,
              date,
            })
            .then(() => {});
          // }
        } else {
          this.$store
            .dispatch('maintenanceSettlement/bulkUpload', {
              file: this.fileBulkMerchant,
              action: this.$route.params.id,
              merchant_id: null,
              date,
            })
            .then(() => {});
        }
      }
    },
    downloadTemplate() {
      if (!this.isUpdate) {
        this.$store
          .dispatch('maintenanceSettlement/downloadTemplate', {
            action: this.$route.params.id,
          })
          .then((response) => {
            this.downloadURL = response;
          });
      }
    },
    clearLastResult() {
      this.$store.commit('maintenanceSettlement/clearLastResult');
    },
  },
};
</script>
